import React, { Component } from "react";
import { prodOptionsData, howItWorksSteps } from "../shared/promo_landing_data";
import PromoElements from "./PromoElements";
import { DEFAULT_CHECK_PRICE, fetchCheckPrice, formatPrice } from "../shared/pricing";
import "./HomeSections.css";

class HowItWorks extends Component {
  constructor(props) {
    super(props);
    this.state = { checkPrice: DEFAULT_CHECK_PRICE };
  }

  componentDidMount() {
    this._isMounted = true;
    fetchCheckPrice().then(price => {
      if (this._isMounted) {
        this.setState({ checkPrice: price });
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        {/* Three steps: sets expectations before anyone commits */}
        <section className="rc-section rc-section--tint">
          <div className="rc-section-head">
            <h2>How it works</h2>
            <p>Three steps, about thirty seconds.</p>
          </div>
          <div className="container">
            <div className="row">
              {howItWorksSteps.map((step, i) => {
                return (
                  <div className="col-lg-4 col-md-4 col-12" key={i}>
                    <div className="rc-step">
                      <div className="rc-step-num">{step.step}</div>
                      <div>
                        <h3>{step.title}</h3>
                        <p>{step.text}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* What each report actually contains */}
        <section className="rc-section">
          <div className="rc-section-head">
            <h2>What&rsquo;s included</h2>
            <p>
              Start free. Unlock the full history for{" "}
              {formatPrice(this.state.checkPrice)}. One payment, no subscription.
            </p>
          </div>
          <div className="container">
            <div className="row align-items-stretch">
              {prodOptionsData && prodOptionsData.map((d, i) => {
                return (
                  <PromoElements d={d} i={i} key={i} price={this.state.checkPrice} />
                );
              })}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default HowItWorks;
